import React from 'react';
import { Btn, Card } from './ui';
import { C } from '../data/constants';

export default function Splash({ onStart, onLogin }) {
  return (
    <div style={{
      flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '2rem 1.5rem', textAlign: 'center',
      background: `linear-gradient(180deg,${C.goldLight},${C.bg})`, overflowY: 'auto',
    }}>
      <div style={{ fontSize: 16, fontWeight: 900, color: C.amber, letterSpacing: '.22em', textTransform: 'uppercase', marginBottom: 6 }}>KABAAK</div>
      <div className="wobble" style={{ fontSize: 76, marginBottom: 8 }}>🌍</div>
      <div style={{ fontSize: 28, fontWeight: 900, color: C.text, lineHeight: 1.2, marginBottom: 10 }}>
        Know Your Roots.<br />Own Your History.
      </div>
      <div style={{ fontSize: 15, color: C.muted, lineHeight: 1.7, marginBottom: 16 }}>
        Discover the real story of Africa's<br />greatest civilizations 🏆
      </div>
      <div style={{ background: '#fff', border: `2px solid ${C.goldLight}`, borderRadius: 12, padding: '10px 12px', marginBottom: 20, fontSize: 13, color: C.muted, fontStyle: 'italic', lineHeight: 1.6 }}>
        "Until the lion learns to write,<br />every story will glorify the hunter."<br />
        <strong style={{ color: C.text }}>— African Proverb</strong>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, width: '100%' }}>
        {[['🌍', '15 Civs'], ['⚔️', 'Duel Friends'], ['🎁', 'Win Prizes']].map(([ic, lb]) => (
          <Card key={lb} style={{ flex: 1, textAlign: 'center', padding: '12px 6px' }}>
            <div style={{ fontSize: 20, marginBottom: 3 }}>{ic}</div>
            <div style={{ fontSize: 12, fontWeight: 700 }}>{lb}</div>
          </Card>
        ))}
      </div>
      <Btn variant="orange" onClick={onStart} style={{ marginBottom: 0 }}>Discover Your History! 🚀</Btn>
      <Btn variant="white" onClick={onLogin}>I have an account</Btn>
    </div>
  );
}
